module.exports = __webpack_public_path__ + "static/img/7-1.a17f628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feature/face/7-1.png
// module id = P0Bk
// module chunks = 1